import { connect } from 'react-redux';
import { compose, withProps, flattenProp, defaultProps } from 'recompose';
import {
  withFirebase,
  isEmpty,
  isLoaded,
  firestoreConnect
} from 'react-redux-firebase';
import { openSubscribeModal } from './store/actions/subscribeModalActions';
import { withStyles } from '@material-ui/core/styles';
import { createMuiTheme } from '@material-ui/core/styles';
import {
  primary,
  secondary,
  error,
  grey,
  grey_dark,
  text__primary
} from './style';

const styles = theme => ({
  spinnerContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyItems: 'center',
    background: 'white',
    zIndex: '1000',
    opacity: '.5'
  },
  downArrow: {
    display: 'block',
    margin: '0 auto'
  }
});

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
    fontFamily: 'Roboto Regular',

    h1: {
      fontFamily: 'Roboto Medium',
      fontSize: '4.6rem'
    },
    h2: {
      fontFamily: 'Roboto Medium',
      fontSize: '3.6rem'
    },
    h3: {
      fontFamily: 'Roboto Medium',
      fontSize: '2.8rem'
    },
    h4: {
      fontSize: '2.2rem'
    },
    h5: {
      fontSize: '1.5rem'
    },
    h6: {
      fontSize: '1.25rem'
    },
    p: {
      fontSize: '1.2rem'
    }
  },
  palette: {
    primary: {
      main: primary
    },
    secondary: {
      main: secondary
    },
    error: {
      main: error
    },
    text: {
      primary: text__primary
    }
  },
  overrides: {
    MuiFilledInput: {
      root: {
        borderRadius: '4px',
        backgroundColor: grey,
        '&:hover': {
          backgroundColor: grey_dark
        },
        '&$focused': {
          backgroundColor: grey_dark
        }
      },
      input: {
        padding: '10.5px 14px'
      },
      underline: {
        '&:before': {
          content: ''
        },
        '&:after': {
          content: ''
        }
      }
    },
    MuiSlider: {
      valueLabel: { '& span': { '& span': { color: 'white' } } },
      markLabel: { color: 'purple' }
    },
    MuiStepIcon: {
      text: { color: 'white', fill: 'white' }
    }
  }
});

const mapStateToProps = state => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
    dealList: state.firestore.ordered.deals,
    campaignList: state.firestore.ordered.campaigns,
    notifications: state.firestore.ordered.notifications,
    escrowReleaseIsProcessing: state.payments.escrowReleaseIsProcessing
  };
};

const mapDispatchToProps = dispatch => {
  return {
    openSubscribeModal: () => dispatch(openSubscribeModal())
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  firestoreConnect(props => {
    if (props.auth.uid && props.profile.isLoaded) {
      const deals = {
        collection: 'deals',
        where: props.profile.isCompany
          ? [['companyId', '==', props.auth.uid]]
          : [['influencerId', '==', props.auth.uid]]
      };
      const ratings = {
        collection: 'ratings',
        where: [['ratedUser', '==', props.auth.uid]]
      };
      const notifications = {
        collection: 'notifications',
        where: [['userId', '==', props.auth.uid]],
        orderBy: [['timestamp', 'desc']],
        limit: 10
      };
      if (props.profile.isCompany) {
        const campaigns = {
          collection: 'campaigns',
          where: [['creator', '==', props.auth.uid]]
        };
        const influencerTags = {
          collection: 'tags',
          doc: 'influencer'
        };
        return [campaigns, deals, ratings, influencerTags, notifications];
      } else {
        return [deals, ratings, notifications];
      }
    } else {
      return [];
    }
  }),
  withFirebase,
  withProps(({ auth, profile }) => ({
    authExists: isLoaded(auth) && !isEmpty(auth),
    auth,
    profile
  })),
  flattenProp('profile'),
  withStyles(styles),
  defaultProps({ theme })
);



// WEBPACK FOOTER //
// ./src/App.enhancer.js